import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import Header from '../components/Header/Header';
import PrivateRoute from '../components/PrivateRoute';
import { AppWrapper, RouteWrapper } from '../components/styledComponents';
import Login from './Login/Login';
import TenderDetails from './TenderDetails/TenderDetails';
import TenderList from './TenderList/TenderList';
import TruckDriverinfo from './TenderDetails/TruckDriverinfo';
import { refreshLogin } from './../store/actions/userActions';

import Location from './Location/Location';
import EditLocation from './Location/EditLocation';

import RateBook from './RateBook/RateBook';
import Dispatch from './Dispatch/Dispatch';
import Templates from './Templates/Templates';
import ShipperConsignee from './ShipperConsignee/ShipperConsignee';
import TruckDriver from './TruckDriver/TruckDriver';
import PickupDisposition from './Maintenance/PickupDisposition/PickupDisposition';
import OrderBy from './Maintenance/OrderBy/OrderBy';
import BillTo from './Maintenance/BillTo/BillTo';
import Orders from './Orders/Orders';
import ElasticDashBoard from './ElasticDashBoard/ElasticDashBoard'
// import Order from './Orders/Order';
import Order from './Orders/Order';
import Trace from './Trace';
import EdiOrder from './EdiOrder/EdiOrder';
import PTReport from "./Reports/PTReport/PTReport"
import PTPaidNoRevenue from "./Reports/PTPaidNoRevenue"
import BillingReport from "./Reports/Billing/index"
import CustomerRevenue from "./Reports/CustomerRevenue"
import CompletedOrder from "./CompletedOrder"
import UserList from './Setting/User/UserList';
import RoleList from './Setting/Role/RoleList';
import PermissionManager from './Setting/Role/PermissionManager';
import PermissionDenied from './Setting/PermissionDenied';
import { getUserPermissionData ,setUserPermission} from '../store/actions/rolePermissionActions';
import config from '../config/config';
import { useHistory } from 'react-router'
import DocumentSearchPage from './Documents/DocumentSearch';
import DocumentUploadPage from './Documents/DocumentUpload';
import RequiredDocumentAudit from './Documents/ReqDocumentAudit';

const routes = [
    {
        component: () => <Redirect to='/login' />,
        path: '/',
        exact: true,
        isPrivate: false,
    },
    // TO DO: create every scene for the router
    {
        component: Login,
        path: '/login',
        exact: true,
        isPrivate: false,
    },
    {
        component: ElasticDashBoard,
        path: '/orders',
        exact: true,
        isPrivate: true,
        permissionKey:'orders' 
    },
    {
        component: TenderList,
        path: '/tenderList',
        exact: true,
        isPrivate: true,
    },
    {
        component: TenderDetails,
        path: '/details/:controlNum/:locationNum',
        exact: true,
        isPrivate: true,
    },

    {
        component: Location,
        path: '/location',
        exact: true,
        isPrivate: true,
    },

    {
        component: EditLocation,
        path: '/addlocation',
        exact: true,
        isPrivate: true,
    },


    {
        component: EditLocation,
        path: '/addlocation/:email',
        exact: true,
        isPrivate: true,
    },

    {
        component: TruckDriverinfo,
        path: '/tenderList/details/:driverId/:locNum/:truckId',
        exact: true,
        isPrivate: true,
        permissionKey:'truckdriver' 
    },
    {
        component: Order,
        path: '/orders/:locationNumber/:controlNumber/:orderType?',
        exact: true,
        isPrivate: true,
        permissionKey:'orders' 
    },
    {
        component: RateBook,
        path: '/ratebook',
        exact: true,
        isPrivate: true,
        permissionKey:'ratebook' 
    },
    {
        component: ElasticDashBoard,
        path: '/elasticdashboard',
        exact: true,
        isPrivate: true,
        permissionKey:'orders' 
    },
    {
        component: Dispatch,
        path: '/dispatch',
        exact: true,
        isPrivate: true,
        permissionKey:'dispatch' 
    },
    {
        component: Templates,
        path: '/templates',
        exact: true,
        isPrivate: true,
        permissionKey:'templates' 
    },
    {
        component: ShipperConsignee,
        path: '/shipperconsignee',
        exact: true,
        isPrivate: true,
        permissionKey: "shipperconsignee"
    },
    {
        component: Trace,
        path: '/trace',
        exact: true,
        isPrivate: true,
        permissionKey:'trace' 
    },
    {
        component: TruckDriver,
        path: '/truckdriver',
        exact: true,
        isPrivate: true,
        permissionKey:'truckdriver' 
    },
    {
        component: PickupDisposition,
        path: '/equip/pick-up/dispo',
        exact: true,
        isPrivate: true,
        permissionKey:'pickupdisposition'
    },
    {
        component: OrderBy,
        path: '/order-by',
        exact: true,
        isPrivate: true,
        permissionKey:'orderby' 
    },
    {
        component: BillTo,
        path: '/bill-to',
        exact: true,
        isPrivate: true,
        permissionKey:'billto' 
    },
    {
        component: EdiOrder,
        path: '/edi-orders',
        exact: true,
        isPrivate: true,
        permissionKey:'ediorders'
    },
    {
        component: PTReport,
        path: '/purchase-transportation-report',
        exact: true,
        isPrivate: true,
        permissionKey:'reports' 
    },
    {
        component: PTPaidNoRevenue,
        path: '/pt-paid-without-revenue-report',
        exact: true,
        isPrivate: true,
        permissionKey:'reports' 
    },
    {
        component: CustomerRevenue,
        path: '/revenue-by-customer-report',
        exact: true,
        isPrivate: true,
        permissionKey:'reports'
    },
    {
        component: BillingReport,
        path: '/billing-report',
        exact: true,
        isPrivate: true,
        permissionKey:'reports'
    },
    {
        component: CompletedOrder,
        path: '/order/completed-order',
        exact: true,
        isPrivate: true,
        permissionKey:'completed' 
    },

    {
        component: UserList,
        path: '/settings/user/list',
        exact: true,
        isPrivate: true, 
        permissionKey:'users'
    },
    {
        component: RoleList,
        path: '/settings/role/list',
        exact: true,
        isPrivate: true,
        permissionKey:'roles'
    },

    {
        component: PermissionManager,
        path: '/settings/role/permission',
        exact: true,
        isPrivate: true,
        permissionKey:'roles'
    },
    {
        component: PermissionDenied,
        path: '/settings/role/permission-denied',
        exact: true,
        isPrivate: false,
    },
    // {
    //     component: ForgotPassword,
    //     path: '/forgot-password',
    //     exact: true,
    //     isPrivate: false,
    // },
    // {
    //     component: ResetPassword,
    //     path: '/reset-password/:token',
    //     exact: true,
    //     isPrivate: false,
    // },
    {
        component: DocumentSearchPage,
        path: '/document/search',
        exact: true,
        isPrivate: true,
        permissionKey:'documents'
    },
    {
        component: DocumentUploadPage,
        path: '/document/upload',
        exact: true,
        isPrivate: true,
        permissionKey:'documents'
    },
    {
        component: RequiredDocumentAudit,
        path: '/document/req-doc-audit',
        exact: true,
        isPrivate: true,
        permissionKey:'documents'
    },
];

export const MainRouter = () => {
    let [isScreen, setIsScreen] = useState()
    const loggedIn = useSelector(({ userReducer }) => userReducer.loggedIn);
    const history = useHistory();
    const dispatch = useDispatch();
    const permissionsData = useSelector(
        (state) => state.rolePermissionReducer.userPermissionData
    );
    useEffect(() => {
        if (loggedIn) {
           dispatch(refreshLogin());
           const userId = localStorage.getItem('userId') ;
            const userIdPG = Number(userId);
           if (userIdPG && (!permissionsData || Object.keys(permissionsData).length === 0) && config.enablePermissionCheck){
                dispatch(getUserPermissionData(userIdPG));
            }
            // if(!userIdPG && config.enablePermissionCheck){
            //     history.push(`/settings/role/permission-denied`)
            // }else if (userIdPG && (!permissionsData || Object.keys(permissionsData).length === 0)){
            //     dispatch(getUserPermissionData(userIdPG));
            // }
        }
    }, [loggedIn, dispatch]);

    const screenStatus = useSelector(({ loadsReducer }) => {
        return loadsReducer.screenStatus
    });
    useEffect(() => {
        setIsScreen(screenStatus)
    }, [screenStatus]);

    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;

        const resizeObserver = new ResizeObserver((entries) => {
            const { width } = entries[0].contentRect;
            console.log('Container width changed:', width);
            window.containerScreenWidth = width;
        });

        resizeObserver.observe(container);

        return () => {
            resizeObserver.unobserve(container);
        };
    }, []);

    // Handle document title
    const location = useLocation();
    useEffect(() => {
        let title = location?.pathname.split("/")
        if (title.includes('orders') && typeof title[3] !== 'undefined') {
            document.title = 'Eagle System' + capitalize(title[1]) + ' #' + title[3];
        } else {
            document.title = 'Eagle System' + capitalize(title[1]);
        }

    }, [location]);

    const capitalize = (str) => {
        let newStr = (str !== '') ? ' - ' + str.charAt(0).toUpperCase() + str.slice(1) : '';
        return newStr;
    }
    return (
        <AppWrapper>
            <Switch>
                <RouteWrapper isScreenClicked={isScreen} ref={containerRef} >
                    {loggedIn && <Header />}
                    {routes.map((route, index) => {
                        // let tempRoute = Object.assign({}, route);
                        let tempRoute = { ...route }
                        
                        return route.isPrivate
                            ? <PrivateRoute key={`Route-${index}`} {...tempRoute} />
                            : <Route key={`Route-${index}`} {...tempRoute} />;
                    })}
                </RouteWrapper>
            </Switch>
        </AppWrapper>
    );
};